import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { StateContext } from "../store/context";
import routes from "./routes";

type ProtectedRouteProps = {
  redirectUrl?: string;
  children?: any;
};
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectUrl = routes.LOGIN,
  children,
}) => {
  const { authUser = null } = useContext(StateContext);
  const tokenInStorage = String(localStorage.getItem("token") || "").trim();
  const hasAuthenticatedUser = !!authUser?.token || !!tokenInStorage;
  if (!hasAuthenticatedUser) {
    return <Navigate to={redirectUrl} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
